export default __webpack_public_path__ + "static/media/red.4b37b9bc.webp";